import { lazy, Suspense } from 'react';
import { Outlet, Route } from 'react-router-dom';

import ErrorBoundaryContainer from '../../components/ErrorBoundaryContainer';
import Loading from '../../components/Loading';

import accountRouter from '../account';

const DastempDashboardComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "dastemp-dashboard" */ '../../pages/dastemp-dashboard'
    ),
);

const dastempDashboardRouter = (
  <Route path="dastemp-dashboard" element={<Outlet />}>
    <Route
      path=":projectId"
      element={
        <Suspense fallback={<Loading />}>
          <ErrorBoundaryContainer
            key="dastemp-dashboard"
            component={<DastempDashboardComponent />}
          />
        </Suspense>
      }
    >
      {accountRouter()}
    </Route>
  </Route>
);

export default dastempDashboardRouter;
